const siteHeader = document.querySelector('.site-header');

function handleFixedHeader() {
  if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
    siteHeader.classList.add('scrolled');
  } else {
    siteHeader.classList.remove('scrolled');
  }
}

window.addEventListener('scroll', handleFixedHeader, { passive: true });